import React, {
  useState,
  useEffect,
  useContext,
  useCallback,
  useRef,
} from "react";
import Header from "./headerweightreport";
import DatePicker from "react-datepicker";
import BranchContext from "../context/branch";
import { getReport, GetprivilegePage, getstore } from "../../services/wms";
import Renderdata from "./renderweightsum";
//import RenderR02 from './renderR02'
import numberWithCommas from "../common/number";
import moment from "moment";
import ScrollToTop from "../common/ScrollToTop";
import { toast } from "react-toastify";
import Select from "./select";

const ReportTotalweight = (props) => {
  const { currentBranch } = useContext(BranchContext);
  const [branchid, setbranchid] = useState(0);
  const [reportlist, setreportlist] = useState([]);
  const [storelist, setstorelist] = useState([]);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [hasMore, setHasMore] = useState(false);
  const [total, settotal] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);
  const [reportId, setreportId] = useState("01");
  const [storeId, setstoreId] = useState(0);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [amount, setamount] = useState(0);
  const [totalweight, settotalweight] = useState(0);
  const [showonscroll, setshowonscroll] = useState(false);
  const [pageSize, setPageSize] = useState(25);
  const [ckPermit, setckPermit] = useState(false);

  useEffect(() => {
    setreportlist([]);
  }, [
    currentBranch,
    reportId,
    startDate,
    endDate,
    branchid,
    pageSize,
    storeId,
  ]);

  useEffect(() => {
    if (!currentBranch) return;
    if (!currentBranch._id ) return;
    if (currentBranch._id == "") return;
    setLoading(true);
    setError(false);

    const loadData = async () => {
      const { data: result } = await getReport(
        reportId,
        moment(startDate, "YYYY-MM-DD").format("YYYY-MM-DD"),
        moment(endDate, "YYYY-MM-DD").format("YYYY-MM-DD"),
        currentBranch && currentBranch._id,
        pageSize,
        pageNumber,
        storeId
      );
      //  console.log('result',result)
      if (result.status === "success") {
        settotal(result.data.total);
        setamount(result.data.amount);
        settotalweight(result.data.weight);
        setreportlist((prevData) => {
          return [...new Set([...prevData, ...result.data.list])];
        });
        setHasMore(result.data.list.length > pageSize - 1);
        setLoading(false);
      }
    };
    loadData();
  }, [
    currentBranch,
    reportId,
    startDate,
    endDate,
    branchid,
    pageSize,
    pageNumber,
    storeId,
  ]);

  useEffect(() => {
    if (!currentBranch) return;
    if (currentBranch._id == "0" || currentBranch._id == "") return;
    const loadPrivilege = async () => {
      const { data: result } = await GetprivilegePage(
        "reportsumary",
        currentBranch._id
      );
      if (result.status === "success") {
        setckPermit(true);
      } else if (result.status === "error") {
        toast.error(result.message);

        if (result.message === "invalid token") {
          const urlGoBack = "logout";
          setTimeout(props.history.replace(urlGoBack), 1000);
        }
      }
    };
    loadPrivilege();
  }, [currentBranch, branchid]);

  useEffect(() => {
    if (!currentBranch) return;
    if (!currentBranch._id) return;
    if (currentBranch._id === "0" || currentBranch._id === "") return;
    const loadStore = async () => {
      const { data: result } = await getstore(currentBranch._id);
      if (result) {
        setstorelist(result);
      }
    };
    loadStore();
  }, [currentBranch, branchid]);

  const handleStartDate = (event) => {
    setStartDate(event);
    setPageNumber(1);
  };
  const handleReportChange = (event) => {
    setreportId(event);
  };
  const handleEndDate = (event) => {
    setEndDate(event);
    setPageNumber(1);
  };

  const observer = useRef();
  const lastBookElementRef = useCallback(
    (node) => {
      // console.log('node = ' ,node);
      if (loading) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        //  console.log(entries[0].isIntersecting,hasMore);

        if (entries[0].isIntersecting && hasMore) {
          setPageNumber((prevPageNumber) => prevPageNumber + 1);
        }
      });
      if (node) observer.current.observe(node);
    },
    [loading, hasMore]
  );

  //   function numberWithCommas(x) {
  //     x = x.toString();
  //     var pattern = /(-?\d+)(\d{3})/;
  //     while (pattern.test(x))
  //         x = x.replace(pattern, "$1,$2");
  //     return x;

  // }
  const handleChange = (event) => {
    setstoreId(event.currentTarget.value);
  };
  const scrollToTop = () => {
    setPageNumber(1);
    // setshowonscroll(false);
  };

  //     console.log(reportlist)

  if (!ckPermit) return <></>;
  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="row">
            <div className="col-auto">
              <div className="m-2">
                <i>
                  จากวันที่ <span className="label"></span>
                </i>
                <div
                  className="mt-2"
                  style={{ marginTop: 20, marginBottom: 20 }}
                >
                  <DatePicker
                    className="datepicker-default form-control"
                    todayButton="Today"
                    selected={startDate}
                    onChange={handleStartDate}
                    // showTimeSelect
                    // timeFormat="HH:mm"
                    // timeIntervals={60}
                    // timeCaption="time"
                    dateFormat="dd/MM/yyyy"
                  />
                </div>
              </div>
            </div>
            <div className="col-auto">
              <div className="m-2">
                <i>
                  ถึงวันที่ <span className="label"></span>
                </i>
                <div className="mt-2">
                  <DatePicker
                    className="datepicker-default form-control"
                    todayButton="Today"
                    selected={endDate}
                    onChange={handleEndDate}
                    //showTimeSelect
                    // timeFormat="HH:mm"
                    // timeIntervals={60}
                    // timeCaption="time"
                    dateFormat="dd/MM/yyyy"
                  />
                </div>
              </div>
            </div>

            <div className="col-auto mt-2">
              <i>
                ประเภทรายงาน <span className="label "></span>
              </i>

              <Header onChange={handleReportChange} />
            </div>
            {reportId === "01" ? (
              <div className="col-auto ">
                <div className="m-2">
                  <div className="from-group">
                  
                    <div className="input-group1">
                    <label className="mb-2">เลือกสถานที่ลง</label>
                      <div className="col-lg-10 p-0">
                        <Select
                          onChange={handleChange}
                          valueProperty="store_id"
                          textProperty="store_name"
                          data={storelist}
                        />
                        {/* <select className="form-select " id="sel1">
                        <option value={0} textname="- เลือกชื่อสินค้า -">
                          - เลือกสถานที่ลง -
                        </option> 

                      </select> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : null}
          </div>
        </div>
        <div className="row">
          <div className="col-auto mt-1 ">
            <p className="text-success">
              แสดงข้อมูล {reportlist ? reportlist.length : 0} / {total} รายการ
            </p>
          </div>

          <div className="col-auto mt-2">
            {"จำนวนเที่ยว"}{" "}
            <span
              className="badge rounded-pill bg-success"
              style={{ fontSize: "13px" }}
            >
              {numberWithCommas(amount)}
            </span>
          </div>

          <div className="col-auto mt-2">
            {"นน."}{" "}
            <span
              className="badge rounded-pill bg-warning text-dark"
              style={{ fontSize: "13px" }}
            >
              {numberWithCommas(totalweight)}
            </span>
            {"ตัน"}
          </div>
        </div>
        <ScrollToTop onClick={scrollToTop} />

        {reportId && (
          <Renderdata
            reportcode={reportId}
            list={reportlist}
            loading={loading}
            error={error}
            lastBookElementRef={lastBookElementRef}
          />
        )}

        {/* { reportId ==='02' && <RenderR02
          
        list = {reportlist}
        loading={loading}
        error={error}
        lastBookElementRef ={lastBookElementRef}
           */}
      </div>
    </>
  );
};

export default ReportTotalweight;
